import { Injectable } from '@angular/core';
import { SendMailRequest, SendMailResponse } from '@shared/index';
import { waitSeconds } from '@reflact/tsutil';
import { WebhookManagerService } from '../webhook-manager.service';
import { UserMailService } from '../user-mail.service';
import { EventManagerAdminService } from '../event-manager/event-manager-admin.service';

@Injectable({
  providedIn: 'root'
})
export class MailManagerAdminService {

  constructor(private webhookManager: WebhookManagerService, private eventManager: EventManagerAdminService, private userMailService: UserMailService) { }
  public async getEnvelope(to: string, subject: string, body: string) {
    await waitSeconds(0);
    return { to, subject, body };

  }
  public async send(request: SendMailRequest): Promise<SendMailResponse> {
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.MAIL.SEND.send', { request });
    const result = await this.userMailService.sendMail(request);
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.MAIL.SEND.done', { request, result });
    return result;
  }
  public async webhook(webhook: string, envelope: { to: string; subject: string; body: string }) {
    await waitSeconds(0);
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.MAIL.WEBHOOK.send', { webhook, envelope });
    const result = await this.webhookManager.call(webhook, envelope);
    this.eventManager._trigger_RAGAI_EVENT('RAGAI.MAIL.WEBHOOK.done', { webhook, envelope, result });




  }

}
